module.exports = __webpack_public_path__ + "img/thumbnail_Saiga_m_albino.7b82cedf.png";